<template lang="pug">
.el-button.follow-button(:class="{ 'pinned': pinned }" :type="following ? 'info' : 'default'" size="small" v-touch @tap="toggleFollowing")
  | {{ following ? 'Following' : 'Follow' }}
</template>

<script>
export default {
  name: "FollowButton",
  props: {
    user: {
      type: Object,
      required: true
    },
    pinned: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      following: false
    };
  },
  methods: {
    toggleFollowing() {
      this.following = !this.following;
    }
  }
};
</script>

<style lang="stylus" scoped>
.follow-button {
  font-weight: bold;

  &.pinned {
    pinned-tr(absolute, 15px);
  }
}
</style>
